import React from 'react';
import {Col, ConfigProvider, Flex, Menu, Row, Space, Typography} from 'antd';
import {createStyles} from 'antd-style';

const {Title, Paragraph} = Typography;
const useStyles = createStyles(({token}) => ({
    navigationPopup: {
        padding: token.padding,
        minWidth: 480,
        background: token.colorBgElevated,
        borderRadius: token.borderRadiusLG,
        boxShadow: token.boxShadowSecondary,
    },
    menuItem: {
        borderRadius: token.borderRadius,
        transition: `all ${token.motionDurationSlow}`,
        cursor: 'pointer',
        '&:hover': {
            background: 'rgba(0, 0, 0, 0.02)',
        },
    },
    menuItemSpace: {
        padding: token.paddingSM,
    },
    leadingHeader: {
        margin: '0 !important',
        paddingBottom: token.paddingXS,
        borderBottom: `1px solid ${token.colorSplit}`,
    },
    marginLess: {
        margin: '0 !important',
    },
}));
const MenuItem = ({title, description}) => {
    const {styles} = useStyles();
    return (
        <div className={styles.menuItem}>
            <Space vertical size={4} className={styles.menuItemSpace}>
                <Title level={5} className={styles.marginLess}>
                    {title}
                </Title>
                <Paragraph type="secondary" className={styles.marginLess}>
                    {description}
                </Paragraph>
            </Space>
        </div>
    );
};
const menuItems = [
    {
        key: 'expenses-main',
        label: 'Основные данные',
    },
    {
        key: 'salary',
        label: 'Зарплаты',
        children: [
            {
                key: 'salary-payrolls',
                label: (
                    <MenuItem title="Ведомости" description="Зарплатные ведомости"/>
                ),
            },
            {
                key: 'salary-settings',
                label: (
                    <MenuItem title="Настройки" description="Настройки модуля зарплат"/>
                ),
            },
        ],
    },
    {
        key: 'expenses',
        label: 'Расходы',
        children: [
            {
                key: 'expenses-period',
                label: (
                    <MenuItem title="Периодические" description="Ведомость периодических расходов"/>
                ),
            },
            {
                key: 'expenses-one-time',
                label: (
                    <MenuItem title="Разовые" description="Ведомости разовых расходов"/>
                ),
            },
            {
                key: 'expenses-settings',
                label: (
                    <MenuItem title="Настройки" description="Настройки модуля расходов"/>
                ),
            },
        ],
    },
];
const ExpensesMenu = ({onSelect}) => {
    const {styles} = useStyles();
    const popupRender = (_, {item}) => {
        return (
            <Flex className={styles.navigationPopup} vertical gap="middle">
                <Typography.Title level={3} className={styles.leadingHeader}>
                    {item.title}
                </Typography.Title>
                <Row gutter={16}>
                    {React.Children.map(item.children, child => {
                        if (!React.isValidElement(child)) {
                            return null;
                        }
                        return (
                            <Col span={12} key={child.key}>
                                {child}
                            </Col>
                        );
                    })}
                </Row>
            </Flex>
        );
    };
    return (
        <ConfigProvider
            theme={{
                components: {
                    Menu: {
                        popupBg: '#fff',
                        horizontalItemSelectedColor: '#1677ff',
                        horizontalItemHoverColor: '#1677ff',
                    },
                    Typography: {
                        titleMarginBottom: 0,
                        titleMarginTop: 0,
                    },
                },
            }}
        >
            <Menu mode="horizontal" items={menuItems} popupRender={popupRender} onClick={v => onSelect(v.key)}/>
        </ConfigProvider>
    );
};
export default ExpensesMenu;